export default __webpack_public_path__ + "static/media/Violin.2ca9b31a.mp3";